import { createReducer } from '@reduxjs/toolkit';
import { LoadingStatus } from '@typings/common';
import { PaymentStatusState } from '@store/payment-status/types';
import { fetchPaymentStatusAction, clearPaymentStatusAction } from '@store/payment-status/actions';

const initialState: PaymentStatusState = {
    paymentStatus: undefined,
    status: LoadingStatus.Idle,
    error: null,
};

export const paymentStatusReducer = createReducer(initialState, (builder) => {
    builder.addCase(clearPaymentStatusAction, (state) => {
        state.status = initialState.status;
        state.paymentStatus = initialState.paymentStatus;
        state.error = initialState.error;
    });
    builder.addCase(fetchPaymentStatusAction.pending, (state) => {
        state.status = LoadingStatus.Loading;
    });
    builder.addCase(fetchPaymentStatusAction.fulfilled, (state, action) => {
        state.status = LoadingStatus.Success;
        if (state.paymentStatus !== action.payload) {
            state.paymentStatus = action.payload;
        }
    });
    builder.addCase(fetchPaymentStatusAction.rejected, (state, action) => {
        state.status = LoadingStatus.Failure;
        state.error = action.payload;
    });
});
